import React from "react";
import { ContainerMain } from "../styles/PageStyles/styleIndex";
import Header from "../components/header";
import Home from "../components/home";
import BannerImages from "../components/Banner/BannerImages";
import { Footer } from "../components/Footer/footer";

const Index = () => {
  return (
    <ContainerMain>
      <Header />
      <Home />
      <BannerImages />
      <Footer />
    </ContainerMain>
  );
};

export default Index;
